export default function ({ store, redirect }) {
  // If the basket is empty
  if (!store.state.cart.items.length) {
    return redirect('/ordering')
  }
}
